import * as t from 'io-ts'
import {User, UserC} from '../User'
import {StoreBaseC} from '../Store'
import {stringOrUndefined} from '../../utils/io-ts-util'

const OfferProviderC = t.union([
  t.literal('access'),
  t.literal('vd'),
  t.literal('ent'),
])
export type OfferProvider = t.TypeOf<typeof OfferProviderC>

const IssueTypeC = t.union([
  t.literal("Business Didn't Accept Offer"),
  t.literal('Out of Business'),
  t.literal('Wrong Address/Moved'),
  t.literal('Code Did Not Work'),
  t.literal('Expired'),
  t.literal('Other'),
])
export type IssueType = t.TypeOf<typeof IssueTypeC>

export const ReportCouponIssueBaseC = t.strict(
  {
    offer: t.type({
      offerKey: t.union([t.string, t.number]),
      title: t.string,
      store: t.type({
        storeKey: stringOrUndefined,
        name: t.string,
        phone: stringOrUndefined,
        address1: stringOrUndefined,
        city: stringOrUndefined,
        state: stringOrUndefined,
        zip: stringOrUndefined,
      }),
    }),
    offerProvider: OfferProviderC,
    user: t.strict({
      name: t.string,
      email: t.string,
      phoneNbr: t.string,
      city: stringOrUndefined,
      state: stringOrUndefined,
      fundraiserName: stringOrUndefined,
    }),
    // token: t.string,
    description: t.string,
    issueType: IssueTypeC,
  },
  'ReportCouponIssue',
)

export type ReportCouponIssueBase = t.TypeOf<typeof ReportCouponIssueBaseC>

export const ReportCouponIssuePayloadC = t.strict(
  {
    ...ReportCouponIssueBaseC.type.props,
    token: t.string,
  },
  'ReportCouponIssuePayloadC',
)

export type ReportCouponIssuePayload = t.TypeOf<
  typeof ReportCouponIssuePayloadC
>

export const ReportCouponIssueLogC = t.strict(
  {
    timestamp: t.number,
    ...ReportCouponIssueBaseC.type.props,
  },
  'ReportCouponIssueLog',
)

export type ReportCouponIssueLog = t.TypeOf<typeof ReportCouponIssueLogC>

// At some point we started adding a field called `key` to 
// results used by the admin portal. I think this was wrong
// but I don't have time to track it down right now.
// The React Admin data provider expects a field called `id`
// not `key`? What is `key` for? I don't know.
export const ReportCouponIssueLogWithKeyC = t.intersection([
  t.type({key: t.string}),
  ReportCouponIssueLogC,
])

export type ReportCouponIssueLogWithKey = t.TypeOf<typeof ReportCouponIssueLogWithKeyC>

export const ListReportCouponIssuesResponseC = t.type({
  data: t.readonlyArray(ReportCouponIssueLogWithKeyC),
  page: t.number,
  total: t.number,
  pageSize: t.number,
  totalPages: t.number,
})

export type ListReportCouponIssuesResponse = t.TypeOf<
  typeof ListReportCouponIssuesResponseC
>
